// PRPs/prds/correcoes-reuniao-05082026.prd.md AC-25 busca por CEP
//
// Ponto único de busca ViaCEP (correcoes-reuniao-05082026-phase-6-local-cidades-e-admin
// .plan.md, Task 1) — extraído da implementação mais completa das 3 duplicatas
// (AdminQuadrasDashboard.tsx:564-592). Isola o CONTRATO observável (valida 8 dígitos,
// lança em CEP inexistente, lança em falha de rede) do mapeamento de campos, que
// permanece em cada chamador (Tasks 2/4/5/6).

export interface EnderecoViaCep {
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  complemento?: string;
}

export async function buscarEnderecoPorCep(cep: string): Promise<EnderecoViaCep> {
  const cepLimpo = cep.replace(/\D/g, '');
  if (cepLimpo.length !== 8) {
    throw new Error('CEP deve ter 8 dígitos');
  }

  const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
  const data = await response.json();

  if (data.erro) {
    throw new Error('CEP não encontrado');
  }

  return data as EnderecoViaCep;
}
